import { Modal, Form, Button } from "react-bootstrap";
import { Formik } from "formik";
import {BiSave, BiX} from "react-icons/bi";
import {useLazyAddEditAccessGroupFacilitiesQuery} from "app/redux/Facility/facilityApi";
// import {getDefaultSelectedFromOptions} from "./DropDownModal";
import { useState, useEffect } from "react";

import MultiselectTreeCtrl from "app/views/dashboard/userDashboard/MultiselectTreeCtrl";
import {useLazyAddCustomPropertyUnitsQuery  } from "app/redux/AMS/amsApi";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import { getDefaultSelectedFromOptions } from "app/views/AccessPoint/AccessPointDetail";
import {useLazyAddEditCustomAccessGroupAccessPointsQuery} from "app/redux/AMS/amsApi";
export default function AddEditAccessPoints(props) {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const initialState = {
    loginUserName: localStorage.getItem("loginUserName") ?? "",
    loginUserPersonId: localStorage.getItem("loginUserPersonId") ?? "",
    loginUserEmail: localStorage.getItem("loginUserEmail") ?? "",
  };
  const [addEditAccessGroupFacilities] = useLazyAddEditAccessGroupFacilitiesQuery();
  const [addEditCustomAccessGroupAccessPoints] = useLazyAddEditCustomAccessGroupAccessPointsQuery();

  const [loading, setLoading] = useState(false);
  const { open,  eventObject, handleSubmit, closeDialog } = props;
  let FacilityData = eventObject.FacilityData;
  let selectedOptions = getDefaultSelectedFromOptions(FacilityData);
  let existingFacilities = getDefaultSelectedFromOptions(FacilityData);
  const [addCustomPropertyUnits] = useLazyAddCustomPropertyUnitsQuery();
  let selectedIncludePropUnits = [];

  const updateSelectedItems = (selectedItems) => {
    selectedOptions = selectedItems;
  }


  const handleFormSubmit  = async () => {
    if(eventObject.accessGroupType !== 'custom'){
        await UpdateAccessGroupFacilities(selectedOptions);
      }
      else{
        await updateCustomAccessGroupFacilities(selectedOptions);
      }
  };

  const updateCustomAccessGroupFacilities = async (selectedFacilities) => {
    showLoader();
    let objExistingFacilities = [];
    existingFacilities.forEach((item) => {
      let tempObj = {};
      tempObj.vendorFacilityId = item.FacilityId;
      objExistingFacilities.push(tempObj);
    });

    let objNewFacilities = [];
    const newFacilities = selectedFacilities;
    newFacilities.forEach((item) => {
      let tempObj = {};
      tempObj.vendorFacilityId = item.FacilityId;
      objNewFacilities.push(tempObj);
    });

    let obj = {};
    obj.companyId = localStorage.getItem('CompanyId');
    obj.vendorAccessGroupId = eventObject.vendorAccessGroupId;
    obj.existingAccessPoints = objExistingFacilities;
    obj.newAccessPoints = objNewFacilities;
    obj.updateBy = localStorage.getItem("loginUserPersonId") ?? "0";
    
    //console.log('addEditCustomAccessGroupAccessPoints -- ', obj);
    await addEditCustomAccessGroupAccessPoints(obj).then((result) => {
      hideLoader()
      if(result.isSuccess){
        handleSubmit(true);
        closeDialog();
      }
    }, error => {
      hideLoader();
    });

    hideLoader();
  }

  const UpdateAccessGroupFacilities = async (selectedFacilities) => {
    showLoader();
    let itemData = eventObject.objAccessGroupDetail;
    let obj = {};
    obj["screenType"] = "Edit";
    obj["Companyid"] = itemData.Companyid;
    obj["PropertyID"] = itemData.PropertyID;
    obj["EntranceID"] = itemData.EntranceID;
    obj["FloorID"] = itemData.FloorID;
    obj["PropertyUnitId"] = itemData.PropertyUnitId;
    obj["updatedBy"] = initialState.loginUserPersonId;
    let Facilities = [];
   
    if (Array.isArray(selectedFacilities)){
      selectedFacilities.forEach((item) => {
        let obj1 = {};
        obj1["FacilityId"] = item.FacilityId;
        obj1["Name"] = item.FacilityName;
        Facilities.push(obj1);
      })
    }

    obj["Facilities"] = Facilities;
    
    //console.log('addEditAccessGroupAccessPoints -- ', obj);
     await addEditAccessGroupFacilities(obj).then((result) => {
         handleSubmit(true);
         hideLoader()
         closeDialog();
     });

     hideLoader();
  };

  
  

  return (
    <Modal show={open} onHide={closeDialog} size="">
      <Formik
        enableReinitialize={true}
        initialValues={eventObject}
        onSubmit={handleFormSubmit}
        >
            
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
          return (
            <>
              <Modal.Header className="bg-primary text-white d-flex flex-wrap justify-content-between align-items-center">
                <h4 className="m-0 text-white">Aksesspunkter</h4>
                <i className="i-Close-Window cursor-pointer text-18"
                onClick={() => closeDialog(false)}/>
              </Modal.Header>

              <Modal.Body>
                <Form onSubmit={handleSubmit}>
                  <Form.Group>
                      <Form.Label>Enheter</Form.Label>
                      {
                        // <MultiselectTreeCtrl refId={'include-propunits'} labelKey={'FacilityName'}   outSelectedItem={updateSelectedItems} options={propertyUnitDetails}></MultiselectTreeCtrl>
                        <MultiselectTreeCtrl refId={'include-propunits'} labelKey={'FacilityName'}   outSelectedItem={updateSelectedItems} options={FacilityData}></MultiselectTreeCtrl>

                      }

                  </Form.Group>
                </Form>
              </Modal.Body>
                <Modal.Footer className={''}>
                    <Button variant="secondary" onClick={() => closeDialog(false)}>
                        <BiX  size={17}></BiX>
                        Lukke
                    </Button>

                    <Button   onClick={handleFormSubmit} variant="primary"  >
                        <BiSave  size={17}></BiSave>   Lagre endringer
                    </Button>
                </Modal.Footer>
            </>
          );
        }}
      </Formik>
      {loader}
    </Modal>
  );
}




